import React from 'react';

export const PartyType = ({ value }) => {
    return (
        <div>
            {value === 'organization' ? <i className='icon icon-organization' /> : <i className='icon icon-face' />}
        </div>
    );
};